import ctl from "@netlify/classnames-template-literals";

export const mobileAppBannerContainer = ctl(`
   flex
   flex-col
   md:flex-row
   items-center
   justify-between
   p-6
   mt-5
   pl-3
   bg-neutral-800
   text-white
   rounded-xl
`);
export const phoneIconWrapper = ctl(`
  h-24
  w-24
  flex
  items-center
  justify-center
`);

export const rightContent = ctl(`
   flex
   items-center
   gap-4
   mt-4
   md:mt-0
`);

export const qrCodeWrapper = ctl(`
   self-center
   hidden
   md:block
`);

export const mobileAppLinksWrapper = ctl(`
   flex 
   flex-row
   md:flex-col
   gap-2
`);
